import { createContext, useContext, useEffect, useState } from "react";
import api from "../lib/api";

const AuthCtx = createContext(null);

export const useAuth = () => useContext(AuthCtx);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = checking, false = logged out

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (!token) {
      setUser(false);
      return;
    }
    api
      .get("/auth/me")
      .then((r) => setUser(r.data))
      .catch(() => {
        localStorage.removeItem("token");
        setUser(false);
      });
  }, []);

  const login = async (identifier, password) => {
    const r = await api.post("/auth/login", { identifier, password });
    if (r.data?.token) {
      localStorage.setItem("token", r.data.token);
    }
    setUser(r.data.user);
    return r.data.user;
  };

  const logout = async () => {
    try {
      await api.post("/auth/logout");
    } catch {
      /* session already gone */
    }
    localStorage.removeItem("token");
    setUser(false);
    window.location.href = "/login";
  };

  const isAdmin = Boolean(user && user.role === "admin");
  const isDirector = Boolean(user && user.role === "director");
  const isStaff = Boolean(user && user.role === "staff");
  const isAgent = Boolean(user && ["agent", "associate"].includes(user.role));
  const isLead = Boolean(user && (user.role === "team_lead" || isDirector || isStaff || user.is_team_lead));
  const canManageTeam = Boolean(isAdmin || isDirector || isStaff || isLead);
  const canManageStaff = Boolean(isAdmin || isDirector);
  const canAddAgent = Boolean(isAdmin || isDirector || isStaff || isLead);
  const canAllotCommission = Boolean(isAdmin || isDirector);

  return (
    <AuthCtx.Provider
      value={{
        user,
        isAdmin,
        isDirector,
        isStaff,
        isAgent,
        isLead,
        canManageTeam,
        canManageStaff,
        canAddAgent,
        canAllotCommission,
        login,
        logout,
      }}
    >
      {children}
    </AuthCtx.Provider>
  );
}
